import { defineMessage } from 'react-intl'

import { ESSENTIALS_HOME_CATEGORY, type TopicViewedMessage } from './types'

export enum ESSENTIALS_MESSAGE {
  RESOURCE_CAROUSEL_WIDGET_CLICK = 'resourceCarouselWidgetClick',
}

export const HOMEBASE_ESSENTIALS_CAROUSEL_CONTENT = {
  essentialsArticleIds: [2068182, 244601, 31977],
  essentialTitle: defineMessage({
    defaultMessage: 'Find your calm',
    description: 'Title of carousel containing self-care content',
  }),
}

export const HOMEBASE_ESSENTIALS_LYRA_SELECT_CAROUSEL_CONTENT = {
  ...HOMEBASE_ESSENTIALS_CAROUSEL_CONTENT,
  essentialTitle: defineMessage({
    defaultMessage: 'Picked for you',
    description: 'Title of carousel containing self-care content for Lyra Select',
  }),
}

export const DEFAULT_ESSENTIALS_HOME_CATEGORIES = [
  ESSENTIALS_HOME_CATEGORY.MEDITATIONS,
  ESSENTIALS_HOME_CATEGORY.COURSES,
  ESSENTIALS_HOME_CATEGORY.BREATHING_EXERCISES,
  ESSENTIALS_HOME_CATEGORY.VIRTUAL_EVENTS,
  ESSENTIALS_HOME_CATEGORY.SOUNDSCAPES,
]

export const ESSENTIALS_HOME_CATEGORY_TO_SUB_PATH: Record<ESSENTIALS_HOME_CATEGORY, string> = {
  [ESSENTIALS_HOME_CATEGORY.MEDITATIONS]: 'topics/cultivating-mindfulness',
  [ESSENTIALS_HOME_CATEGORY.COURSES]: 'courses',
  [ESSENTIALS_HOME_CATEGORY.BREATHING_EXERCISES]: 'tools/breathing-exercises',
  [ESSENTIALS_HOME_CATEGORY.VIRTUAL_EVENTS]: 'events',
  [ESSENTIALS_HOME_CATEGORY.SOUNDSCAPES]: 'tools/soundscapes',
}

/** Cache key for cached essentials content from the homebase carousel */
export const ESSENTIALS_HOME_CACHE_KEY = 'ESSENTIALS_HOME_CACHE_KEY'

export const ESSENTIALS_MIXES_PATH = 'mixes'
/** Goodness refers to the orientation mixes modal as 'o' */
export const ESSENTIALS_ORIENTATION_MIXES_MODAL = 'o'

export const MANAGING_TEAMS_TOPIC_ID = '2470691'
export const TOPIC_VIEWED_EVENT: TopicViewedMessage['event'] = 'TOPIC_VIEWED'
export const ESSENTIALS_MANAGING_TEAMS_SUBPATH = 'topics/managing-teams'

export const ESSENTIALS_SEARCH_PATH = '/essentials/search'
